module.exports = __webpack_public_path__ + "static/flags/YM-154d5ed59c754457316f3c03d4c21755.gif";